import axiosInstance from "../axios/axiosInstance";
import { buildApiUrl } from "../../config/api";

const API = buildApiUrl("/interviewQuestionApp/candidate-exam/");

export const examReportService = {
  async getAll() {
    try {
      const response = await axiosInstance.get(API);
      return { success: true, data: response.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
        data: [],
      };
    }
  },
};
